// #NOTE: [EM] This model shold also contain story type
export class StoryChapterThumbnail {
    storyId: string;
    chapterId: string;
    urls: {
        small: string,
        large: string
    };
    snapshot?: string;
}
